module.exports = __webpack_public_path__ + "static/media/tail-right.21f1ed52.svg";